export const Meta = {
  STRUCTURE: 'structure',
  TAXONOMY: 'taxonomy',
};

export const TooltipEvents = {
  ON_HOVER_EVENT: 'tooltipOnHoverHide',
  ON_CLICK_EVENT: 'tooltipOnClickHide',
  hideOnHoverTooltips: () => window.dispatchEvent(new CustomEvent('tooltipOnHoverHide')),
  hideOnClickTooltips: () => window.dispatchEvent(new CustomEvent('tooltipOnClickHide')),
};

export const types = {
  substance: 'DAT.MRN',
  target: 'TARGET.HDR_KEY',
  bioassay: 'DAT.ANAME',
  targetSpecies: 'DAT.TSPECIE',
  biologicalSpecies: 'DAT.BSPECIE',
  effect: 'DAT.EFFECT',
  parameter: 'DAT.VTYPE',
  cellLine: 'DAT.BCELL',
};

export const titles = {
  [types.target]: 'Target details',
  [types.bioassay]: 'Bioassay details',
  [types.targetSpecies]: 'Target species details',
  [types.biologicalSpecies]: 'Biological species details',
  [types.effect]: 'Effect details',
  [types.parameter]: 'Parameter details',
  [types.cellLine]: 'Cell line details',
};
